<template>
  <div style="padding: 20px; background: rgb(221, 225, 230); border: 1px solid rgb(204, 204, 204)">
    <v-card class="mb-4" v-if="list_access">
      <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
        <div class="col-md-12">
          <div class="col-md-12" style="background: white">
            <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
            <v-divider class="mt-0"></v-divider>

            <div class="row pt-2">
              <div class="col-md-3">
                <v-text-field v-model="filters.date_from" density="comfortable" type="date" name="date_from" label="Desde" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="filters.date_to" density="comfortable" type="date" name="date_to" label="hasta" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacen" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox v-if="!isClient()" v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clients" label="Cliente" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox
                  v-model="filters.product"
                  density="comfortable"
                  name="product"
                  item-title="label"
                  item-value="id"
                  :items="products"
                  label="Producto"
                  autocomplete="off"
                  :disabled="disabled"
                  :loading="loading_products"
                  clearable
                ></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox
                  v-model="filters.document_types"
                  density="comfortable"
                  name="document_types"
                  item-title="name"
                  item-value="id"
                  :items="documents_types"
                  label="Tipo de Documento"
                  autocomplete="off"
                  :disabled="disabled"                  
                  multiple
                  clearable
                  chips
                ></v-combobox>
              </div>              

              <div class="col-md-3">
                <v-checkbox
                  v-model="filters.solo_promedio_dias"
                  density="comfortable"
                  name="solo_promedio_dias"
                  label="Promediar dias"
                  :disabled="disabled"                  
                ></v-checkbox>
              </div>
              <div class="col-md-3">
                <v-checkbox
                  v-model="filters.solo_dias_con_movimiento"
                  density="comfortable"
                  name="solo_dias_con_movimiento"
                  label="Solo dias con movimiento de stock"
                  :disabled="disabled"
                ></v-checkbox>
              </div>
              <div class="col-md-3">
                <v-checkbox
                  v-model="filters.incluir_ajustes_stock"
                  density="comfortable"
                  name="incluir_ajustes_stock"
                  label="Incluir ajustes de stock"
                  :disabled="disabled"
                ></v-checkbox>
              </div>
              <div class="col-md-6"></div>
              
              <div class="col-md-3 mb-2" style="display: flex; justify-content: end">
                <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
                <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <v-card v-if="list_access">
      <v-card-title>
        <v-row align="center" class="mt-1">
          <v-col>
            <span>{{ page_title }}</span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>

      <!-- v-if="list_access" -->

      <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
        <!-- Header personalizado con agrupación -->
        <template v-slot:headers>
          <tr>
            <!-- Headers normales -->
            <th class="text-left">{{ this.headers[0].title }}</th>
            <th class="text-left">Almacén</th>
            <th class="text-left">Cliente</th>
            <th class="text-left">Producto</th>
            <th class="text-left">Presentación</th>
            <!-- Grupo Stock -->
            <th class="text-center group-header stock-group" colspan="3">Stock</th>
            <!-- Grupo Volumen -->
            <th class="text-center group-header volume-group" colspan="3">Volumen (m³)</th>
          </tr>
          <tr class="sub-header-row">
            <!-- Espaciadores para headers normales -->
            <th class="bg-blue-grey-lighten-5"></th>
            <th class="bg-blue-grey-lighten-5"></th>
            <th class="bg-blue-grey-lighten-5"></th>
            <th class="bg-blue-grey-lighten-5"></th>
            <th class="bg-blue-grey-lighten-5"></th>
            <!-- Sub-headers Stock -->
            <th class="text-center sub-header stock-sub">Ingresos</th>
            <th class="text-center sub-header stock-sub">Egresos</th>
            <th class="text-center sub-header stock-sub">Stock Final</th>
            <!-- Sub-headers Volumen -->
            <th class="text-center sub-header volume-sub">Ingresos</th>
            <th class="text-center sub-header volume-sub">Egresos</th>
            <th class="text-center sub-header volume-sub">Stock Final</th>
          </tr>
        </template>

        <template v-slot:item="{ item }">
          <tr>
            <td>{{ (item.creation_date)?item.creation_date:item.total_dias }}</td>
            <td>{{ item.almacen_name }}</td>
            <td>{{ item.client_name }}</td>
            <td>
              {{ item.product_name }}
              <span class="text-caption text-grey-600 d-block">SKU: {{ item.product_sku }}</span>
            </td>
            <td>{{ item.presentation_type }}</td>

            <!-- Grupo Stock -->
            <td class="text-center stock-data">{{ item.total_ingresos }}</td>
            <td class="text-center stock-data">{{ item.total_egresos }}</td>
            <td class="text-center stock-data font-weight-bold">{{ item.stock }}</td>

            <!-- Grupo Volumen -->
            <td class="text-center volume-data">{{ item.vol_total_ingresos }}</td>
            <td class="text-center volume-data">{{ item.vol_total_egresos }}</td>
            <td class="text-center volume-data font-weight-bold">{{ item.vol_total_stock }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { reportsService } from "@/libs/ws/reportsService";
import { documentsTypeService } from "@/libs/ws/documentsTypeService";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import { productoService } from "@/libs/ws/productoService";
import UserTypeConstant from "@/constants/user_type";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
export default {
  components: {},
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      service: reportsService,
      page_title: "Movimiento de Stock",
      userTypeConstant: UserTypeConstant,
      user_type: null,
      headers: [],
      headers_no_promedio: [
        // Headers simplificados para uso con template personalizado
        { title: "Fecha", value: "creation_date" },
        { title: "Almacen", value: "almacen_name" },
        { title: "Cliente", value: "client_name" },
        { title: "Producto", value: "product_name" },
        { title: "Presentacion", value: "presentation_type" },
        { title: "Stock Ingresos", value: "total_ingresos" },
        { title: "Stock Egresos", value: "total_egresos" },
        { title: "Stock Final", value: "stock" },
        { title: "Volumen Ingresos", value: "vol_total_ingresos" },
        { title: "Volumen Egresos", value: "vol_total_egresos" },
        { title: "Volumen Stock", value: "vol_total_stock" },
      ],
      headers_promedio: [
        // Headers simplificados para uso con template personalizado
        { title: "Cantidad de Dias", value: "cantidad_dias" },
        { title: "Almacen", value: "almacen_name" },
        { title: "Cliente", value: "client_name" },
        { title: "Producto", value: "product_name" },
        { title: "Presentacion", value: "presentation_type" },
        { title: "Stock Ingresos", value: "total_ingresos" },
        { title: "Stock Egresos", value: "total_egresos" },
        { title: "Stock Final", value: "stock" },
        { title: "Volumen Ingresos", value: "vol_total_ingresos" },
        { title: "Volumen Egresos", value: "vol_total_egresos" },
        { title: "Volumen Stock", value: "vol_total_stock" },
      ],
      filters: {
        date_from: new Date(
          new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        almacen: null,
        client: null,
        product: null,
        documents_types: [],
        solo_promedio_dias: false,
        solo_dias_con_movimiento: false,
        incluir_ajustes_stock: false,
      },
      loading_products: false,
      almacenes: [],
      clients: [],
      products: [],
      documents_types: [],
    };
  },
  mounted() {
    this.headers = this.headers_no_promedio;
    this.user_type = localStorage.getItem("user_type");
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    //recorro los headers y saco el cliente si el usuario es el cliente
    this.headers = this.headers.filter((header) => {
      if (header.visible_for_client || header.visible_for_client == undefined) {
        return true;
      }
      return !this.isClient();
    });

    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
    this.loadAlmacenes();
    this.loadClientes();
    this.loadProductsMinify();
    this.loadDocumentTypes();
  },
  watch: {
    'filters.solo_promedio_dias'(newVal) {
      if (newVal) {
        this.filters.solo_dias_con_movimiento = false;
      }
    },
    'filters.solo_dias_con_movimiento'(newVal) {
      if (newVal) {
        this.filters.solo_promedio_dias = false;
      }
    },    
  },
  methods: {
    loadDocumentTypes() {
      documentsTypeService
        .filter()
        .then((response) => {
          this.documents_types = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadClientes() {
      if(this.isClient()){
        return;
      }
      
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.loadClientes error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.loadAlmacenes error");
          console.log(e);
        });
    },
    loadProductsMinify() {
      this.loading_products = true;
      productoService
        .list_minify()
        .then((response) => {
          this.products = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_products = false;
        });
    },
    getFilterParams() {
      const params = { ...this.filters };
      if (this.filters.product && this.filters.product.sku) {
        params.sku = this.filters.product.sku;
      }
      delete params.product;
      return params;
    },
    loadList(service, param = null) {
      this.loading = true;

      param = this.getFilterParams();              

      this.open_filter = false;
      reportsService
        .movimientos_stock(param)
        .then((response) => {
          //this.setHeader();
          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }

          if(this.filters.solo_promedio_dias){
            this.headers = this.headers_promedio;
          }else{
            this.headers = this.headers_no_promedio;
          }
        })
        .catch((e) => {
          console.log("service.stock_pallet error");
          console.log(e);
          this.loading = false;
        });
    },
    filter() {
      this.loadList(this.service, this.filters);
    },
    exportFile() {
      var param = { ...this.getFilterParams() }; // Copia de this.filters
      param["export"] = true;
      this.exportExcel(Constant.SECTION_REPORTS + "/movimientos-stock", param, "MovimientoStock.xlsx");
    },
  },
};
</script>

<style scoped>
/* Headers agrupados */
.group-header {
  background-color: #f5f5f5 !important;
  border-bottom: 2px solid #e0e0e0 !important;
}

.stock-group {
  background-color: #e8f5e8 !important;
  border-left: 3px solid #4caf50 !important;
}

.volume-group {
  background-color: #e3f2fd !important;
  border-left: 3px solid #2196f3 !important;
}

.sub-header {
  background-color: #fafafa !important;
  font-weight: 500 !important;
  font-size: 0.675rem !important;
  border-bottom: 1px solid #e0e0e0 !important;
}

.sub-header-row th {
  height: 30px !important;
}

.stock-sub {
  background-color: #f1f8e9 !important;
}

.volume-sub {
  background-color: #e1f5fe !important;
}

/* Datos agrupados */
.stock-data {
  background-color: #f9fff9 !important;
}

.volume-data {
  background-color: #f0f8ff !important;
}

/* Separación visual entre grupos */
.stock-data:last-of-type {
  border-right: 2px solid #4caf50 !important;
}

.volume-data:first-of-type {
  border-left: 2px solid #2196f3 !important;
}

.nowrap {
  white-space: nowrap;
}
</style>
